// extracted by mini-css-extract-plugin
export var modal = "_g0-0";